import { render, staticRenderFns } from "./Label_FB_Dialog.vue?vue&type=template&id=7960295a&"
import script from "./Label_FB_Dialog.vue?vue&type=script&lang=js&"
export * from "./Label_FB_Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports